import { render, staticRenderFns } from "./AddInfusionDrugPrescription.vue?vue&type=template&id=bb2975ce&scoped=true"
import script from "./AddInfusionDrugPrescription.vue?vue&type=script&lang=js"
export * from "./AddInfusionDrugPrescription.vue?vue&type=script&lang=js"
import style0 from "./AddInfusionDrugPrescription.vue?vue&type=style&index=0&id=bb2975ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2975ce",
  null
  
)

export default component.exports